import { Dispatch, SetStateAction } from "react";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import ModalComponent from "../../../../../Components/Modais";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import Table from "../../../../../Components/Table";
import { DeletarEtapaReguaController } from "../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import { IReguaEtapa } from "../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import ModalCadastrarEtapa from "./ModalCadastrarEtapa";
import ModalEditarEtapa from "./ModalEditarEtapa";

interface IFormData {
    DS_NOME_ETAPA: string;
    NR_ETAPA: number;
    FL_COBRANCA_PREVENTIVA: boolean;
}

interface IEtapaDaRegua {
    updateList: () => Promise<void>;
    LstEtapaRegua: IReguaEtapa[] | undefined;
    IdRegua: string;
    ListarReguaEtapa: () => Promise<IReguaEtapa[]>;

    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
    modal: IComponentModal | undefined;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;

    onSubmit: (formData: IFormData) => void;
}

export default function EtapaDaRegua(props: IEtapaDaRegua) {
    const rowTable = (cell: any, row: IReguaEtapa) => {
        return (
            <div
                className="rowCapysRC m-0 p-2"
                key={row.ID_CASO_COBRANCA_REGUA_ETAPA}
            >
                <div className="col-12 d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex flex-column">
                        <h6 className="mb-0">{row.DS_NOME_ETAPA}</h6>
                        <div className="d-flex flex-wrap">
                            {row.FL_COBRANCA_PREVENTIVA ? (
                                <div className="label label-success label-inline mr-2 my-1">
                                    {" "}
                                    Preventivo{" "}
                                </div>
                            ) : (
                                <div className="label label-danger label-inline mr-2 my-1">
                                    {" "}
                                    Não Preventivo{" "}
                                </div>
                            )}
                            {row.NR_ETAPA && (
                                <div className="label label-primary label-inline mr-2 my-1">
                                    {row.NR_ETAPA}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex flex-wrap">
                            <button
                                type="button"
                                className="btn btn-light-primary border border-primary font-weight-bold m-1 d-flex align-items-center"
                                data-toggle="collapse"
                                data-target="#collapseForm"
                                aria-expanded="false"
                                aria-controls="collapseForm"
                                onClick={() => {
                                    props.setShow(true);
                                    props.setModal({
                                        Component: () => (
                                            <ModalEditarEtapa
                                                idEtapa={
                                                    row.ID_CASO_COBRANCA_REGUA_ETAPA
                                                }
                                                idRegua={Number.parseInt(
                                                    props.IdRegua
                                                )}
                                                updateList={props.updateList}
                                            />
                                        ),
                                        headerComponent: "Editar Ações",
                                        IconHeader: faEdit,
                                        size: "lg",
                                        scrollable: true,
                                    });
                                }}
                            >
                                Editar
                            </button>

                            <button
                                className="btn btn-light-danger border border-danger font-weight-bold m-1"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar esta etapa da régua?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarEtapaReguaController(
                                                row.ID_CASO_COBRANCA_REGUA_ETAPA
                                            ).then(() => {
                                                props.updateList();
                                                props.ListarReguaEtapa();
                                            });
                                        }
                                    });
                                }}
                            >
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const columns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA",
            text: "Etapas da Fila",
            formatter: rowTable,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
    ];

    return (
        <div>
            <div className="d-flex justify-content-end mb-5">
                <button
                    className="btn btn-success font-weight-bold"
                    onClick={() => {
                        props.setShow(true);
                        props.setModal({
                            Component: () => (
                                <ModalCadastrarEtapa
                                    idRegua={Number.parseInt(props.IdRegua)}
                                    setShow={props.setShow}
                                    updateList={props.updateList}
                                    onSubmit={props.onSubmit}
                                />
                            ),
                            noFooter: true,
                            noHeader: true,
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} size="lg" className="mr-2" />{" "}
                    Nova Etapa
                </button>
            </div>
            {props.LstEtapaRegua && (
                <Table
                    columns={columns}
                    data={props.LstEtapaRegua}
                    keyField={"ID_CASO_COBRANCA_REGUA_ETAPA"}
                    noDataIndication={
                        <div className="text-black-50 text-center">
                            Nenhuma Etapa Encontrada
                        </div>
                    }
                />
            )}
            <ModalComponent
                show={props.show}
                setShow={props.setShow}
                ModalComponent={props.modal}
            />
        </div>
    );
}
